import { environment } from '@environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { Component, TemplateRef, ViewChild } from '@angular/core';

import { TranslocoService } from '@jsverse/transloco';

import { filter, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import { LoginTranslations } from '@speaksee/speaksee-angular-core/src/lib/components/login';
import { SettingsService } from '@app/services/settings.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  @ViewChild('emailDialog', { static: true }) emailDialog: TemplateRef<any>;
  notifier = new Subject();

  email = '';
  returnUrl = '';

  loginLabels: Observable<LoginTranslations>;
  isDarkMode$ = this.settingsService.darkMode$;
  supportURL: string;

  readonly requestEmail = `${environment.speaksee.mySpeaksee}/account/email-confirmation`;
  readonly resetPasswordURL = `${environment.speaksee.mySpeaksee}/account/password-reset-request`;
  readonly registerURL = `${environment.speaksee.mySpeaksee}/account/register`;
  constructor(
    private router: Router,
    private translate: TranslocoService,
    private dialog: MatDialog,
    private settingsService: SettingsService
  ) {
    const currentLang = this.translate.getActiveLang();
    this.supportURL = `https://support.speak-see.com/${currentLang}`;
    
    this.translate.langChanges$.pipe(takeUntilDestroyed()).subscribe((lang) => {
      this.supportURL = `https://support.speak-see.com/${lang}`;
    });
    
    this.loginLabels = this.translate.langChanges$.pipe(
      takeUntilDestroyed(),
      filter((x) => !!x),
      map(() => ({
        signInText: this.translate.translate('login.sign_in'),
        emailLabel: this.translate.translate('login.email_label'),
        passwordLabel: this.translate.translate('login.password_label'),
        error: {
          email: this.translate.translate('login.error.email'),
          password: this.translate.translate('login.error.password'),
          emailNotActivated: this.translate.translate(
            'login.error.email_not_activated'
          ),
          invalidUserOrPassword: this.translate.translate(
            'login.error.invalid_user_or_password'
          ),
          unknownError: this.translate.translate('login.error.unknown_error'),
        },
      }))
    );
  }

  async onLogin() {
    if (this.returnUrl) {
      await this.router.navigateByUrl(this.returnUrl);
    } else {
      await this.router.navigate(['/microphone-kits']);
    }
  }

  onUnverified(email: string) {
    this.email = email;
    this.dialog.open(this.emailDialog);
  }

  onError(error: any) {
    console.log(error);
  }
}
